import KioskAvatar from "./KioskAvatar";

export default KioskAvatar;
